import Instance from '../../../../Axios';

// New Actions for the app

const GetObrasMateriais = () => async (dispatch) => {
  await Instance()
    .get(`/construcoes/obras/all/materiais`)
    .then(({ data }) => {
      dispatch({ type: 'GET_OBRAS_MATERIAIS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObrasMateriais;